module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [_c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t身份认证\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者四要素认证：姓名、身份证号、银行卡号、银行预留手机号码四要素未通过情况需要人脸识别\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t网络服务协议确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对网络服务协议确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t投资者信息及合格投资者承诺函确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对投资者信息表、投资者资料、合格投资者承诺函进行确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t投资者信息及合格投资者承诺函确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对投资者信息表、投资者资料、合格投资者承诺函进行确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t风险承受力测评\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者根据实际情况对风险承受能力进行测评\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t数字证书申请表上传\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者上传签署盖章的数字证书申请表\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t等待管理人审核\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t特定对象确认提交管理人后台等待管理人审核，审核通过特定对象完成，审核失败，根据失败原型修改相关资料\n\t\t\t")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cfd89bf"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Guide/Confirm/orgNorConfirm.vue
// module id = 1017
// module chunks = 1